import { restClient } from '../../client';

export const enum ReliasTrainingStatus {
  notStarted = 'not_started',
  inProgress = 'in_progress',
  completed = 'completed',
}

export const enum RequiredTrainingKey {
  hipaaAndSecurity = 'hipaa_and_security',
  prescriber = 'prescriber',
}

export type RequiredTrainingTask = {
  // null until Relias has synced this training at least once for the provider — there's no row
  // (and so no id) to reference yet.
  id: string | null;
  key: RequiredTrainingKey;
  label: string;
  status: ReliasTrainingStatus;
  startedAt: string | null;
  lastAccessedAt: string | null;
  completedAt: string | null;
};

// The full, unfiltered dump of every Relias course synced for the provider (including optional
// CE courses beyond the two that are actually required) — general-purpose, not specific to the
// required-trainings to-do. Pass `requiredOnly: true` to getProviderTrainings to filter server-side.
// `key` is set (by the backend) when this row's courseId matches one of the required trainings —
// use it to key any required-trainings-specific display logic instead of the raw courseId, since
// courseId is a Relias implementation detail that could change.
export type ReliasTraining = {
  id: string;
  enrollmentId: string | null;
  courseId: string;
  courseCode: string;
  courseTitle: string;
  key: RequiredTrainingKey | null;
  status: ReliasTrainingStatus;
  dueAt: string | null;
  startedAt: string | null;
  lastAccessedAt: string | null;
  completedAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
};

export type ProviderTrainingsResponse = {
  lastSyncedAt: string | null;
  trainings: ReliasTraining[];
};

export const getProviderTrainings = (providerId: string, opts?: { requiredOnly?: boolean }) =>
  restClient.request<{ data: ProviderTrainingsResponse }>(`/api/v1/provider/${providerId}/trainings`, {
    method: 'GET',
    params: {
      required_only: opts?.requiredOnly ?? false,
    },
  });
